// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let QueryParams = require("../../../reason/QueryParams.bs.js");
let Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");

let config = Object.fromEntries([[
    "draftId",
    QueryParams.UseQueryParams.ParamConfigs.numberParam
  ]]);

let ParamsConfig = {
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make(ParamsConfig);

let QueryParams_use = UseQueryParams.use;

let QueryParams$1 = {
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: QueryParams_use
};

function decodeTime(time) {
  let match = Stdlib_Option.map(time, Types__Time.decode);
  if (match !== undefined && match.TAG === "Ok") {
    return Primitive_option.some(match._0);
  }
}

function toValidationResult(valid) {
  if (valid !== undefined) {
    if (typeof valid === "object") {
      if (valid.NAME === "Error") {
        return {
          TAG: "Error",
          _0: valid.VAL
        };
      } else {
        return {
          TAG: "Ok",
          _0: "NoValue"
        };
      }
    } else if (valid === "Valid") {
      return {
        TAG: "Ok",
        _0: "Valid"
      };
    } else {
      return {
        TAG: "Ok",
        _0: "NoValue"
      };
    }
  } else {
    return {
      TAG: "Ok",
      _0: "NoValue"
    };
  }
}

function useFormControl(fieldUpdater, initialTouched, initialValue, valid) {
  let updateDraft = PropertyWizardFormRelay.useUpdateDraft();
  let match = React.useState(() => initialValue);
  let setValue = match[1];
  let value = match[0];
  let match$1 = React.useState(() => initialTouched);
  let setTouched = match$1[1];
  let touched = match$1[0];
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  let match$3 = React.useState(() => valid === "Valid");
  let setHasBeenValid = match$3[1];
  let hasBeenValid = match$3[0];
  let update = value => updateDraft(current => {
    switch (fieldUpdater.TAG) {
      case "Draft" :
        return fieldUpdater._0(current, value);
      case "DraftProperty" :
        return {
          chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
          draftProperty: fieldUpdater._0(current.draftProperty, value),
          message: current.message,
          serverDraftId: current.serverDraftId,
          status: current.status,
          subject: current.subject,
          timeZone: current.timeZone
        };
      case "Showing" :
        let showingNum = fieldUpdater.showingNum;
        let showings = current.draftProperty.showings;
        let newrecord = {...current.draftProperty};
        let targetShowing = showings[showingNum];
        let tmp;
        if (targetShowing !== undefined) {
          let updatedShowing = fieldUpdater.updater(targetShowing, value);
          let updatedShowingsList = showings.slice();
          updatedShowingsList.splice(showingNum, 1, updatedShowing);
          tmp = updatedShowingsList;
        } else {
          tmp = showings;
        }
        newrecord.showings = tmp;
        return {
          chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
          draftProperty: newrecord,
          message: current.message,
          serverDraftId: current.serverDraftId,
          status: current.status,
          subject: current.subject,
          timeZone: current.timeZone
        };
    }
  });
  React.useEffect(() => {
    if (!hasBeenValid && valid === "Valid") {
      setHasBeenValid(param => true);
    }
  }, [valid !== undefined ? (
        typeof valid === "object" ? "Error" : "Valid"
      ) : undefined]);
  let tmp;
  let exit = 0;
  if (hasBeenValid || touched) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = valid !== undefined ? (
        typeof valid === "object" ? "error" : "ok"
      ) : undefined;
  }
  return {
    value: value,
    valueAsString: value !== undefined ? String(Primitive_option.valFromOption(value)) : "",
    onBlur: () => {
      if (!touched) {
        setTouched(param => true);
        update(value);
      }
      setFocused(param => false);
    },
    onFocus: () => setFocused(param => true),
    onChange: value => {
      setValue(param => value);
      update(value);
    },
    focused: match$2[0],
    valid: hasBeenValid || touched ? valid : undefined,
    status: tmp
  };
}

function allValid(validations) {
  if (validations.every(validation => validation !== undefined ? typeof validation !== "object" : true)) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function allSubStepsValid(validations) {
  if (validations.every(validation => validation !== "Invalid")) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function optResultToDummyStringResult(optResult) {
  return Stdlib_Option.map(optResult, m => {
    if (typeof m === "object") {
      return {
        NAME: "Error",
        VAL: ""
      };
    } else {
      return "Valid";
    }
  });
}

let FormUtils = {
  decodeTime: decodeTime,
  noneIfEmpty: Form__Helpers.noneIfEmpty,
  toValidationResult: toValidationResult,
  FieldError: undefined,
  useFormControl: useFormControl,
  allValid: allValid,
  allSubStepsValid: allSubStepsValid,
  optResultToDummyStringResult: optResultToDummyStringResult
};

function useMlsStatusCheck() {
  let mlsStatusCheckFeatureEnabled = FeaturesV3.useFeatureFlipper("CheckPropertyStatusOnMLS") === "on";
  let chapterHasPreference = UserSession.useChapterPreference("MlsComingSoon");
  if (mlsStatusCheckFeatureEnabled) {
    return chapterHasPreference !== "OFF";
  } else {
    return false;
  }
}

exports.QueryParams = QueryParams$1;
exports.FormUtils = FormUtils;
exports.useMlsStatusCheck = useMlsStatusCheck;
/* config Not a pure module */
